
<div :style = "hover ? 'background-color: #f0f0f0' : ''">
    <div class="v-flex lm-border pa-1 pl-2 status-row">
        <div
            v-for  = "(data, index) in incident.data"
            :key   = "index"
            class  = "unit-header-step"
            :class ="unitStepStatus(data, index)"
        >
            {{ data.sequence }}
        </div>

        <c-clipboard-chip
            v-if="clipboardUnit(incident.data[0], unit)"
            size="small"
        />
    </div>

    <p-inc-navigation-unit
        :site  = "unit"
        style  = "width: 300px;"
        :class = "background"
        :style = "hover ? 'background-color: #f0f0f0' : ''"
        @remove = "onRemove"
    />
</div>
